import { render, staticRenderFns } from "./SettingsRuleText.vue?vue&type=template&id=5f75e091&"
import script from "./SettingsRuleText.vue?vue&type=script&lang=js&"
export * from "./SettingsRuleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports